import api from "../api";

export const useUpdatedUser = (data) =>
  api.put("/user", data).then((res) => res.data);
